import * as React from "react";
import DevExpress from "devextreme";
import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, FilterRow, HeaderFilter, Pager, Paging, RemoteOperations, SearchPanel, StateStoring, Selection } from "devextreme-react/data-grid";
import { ActiveColumnOptions, generateDS } from "../../../utils/datasource";
import { DownloadChart } from "./charts/DownloadChart";
import { StreamChart } from "./charts/StreamChart";
import { Platform, PlatformContext } from "../../../components/context/platform";
import { Environment } from "../../../env";
import { PlatformRenderer, sp } from "../../../utils/platformSelect";

const LabelDatasource = generateDS(Environment.CREATE_API, 'label')
const GenreDatasource = generateDS(Environment.CREATE_API, 'genre')
export class Compare extends React.Component<{}, { albumIds: string[] }> {
    private dataGrid: DataGrid | null;
    private latinoDataSource = generateDS(Environment.LATINO_API, 'album')
    private supremeDataSource = generateDS(Environment.API, 'album')
    private createDataSource = generateDS(Environment.CREATE_API, 'soundpackage')

    static contextType = PlatformContext
    context!: Platform

    constructor(props) {
        super(props);
        this.state = {
            albumIds: []
        }
    }

    componentDidMount() {
        configureAlbumCustomDatasource(this.dataGrid!, this.latinoDataSource as any)
        configureAlbumCustomDatasource(this.dataGrid!, this.supremeDataSource as any)
    }

    getSnapshotBeforeUpdate() {
        return this.context
    }

    componentDidUpdate(_a, _b, prevContext) {
        if (this.context != prevContext) {
            this.setState({ albumIds: [] })
        }
        configureAlbumCustomDatasource(this.dataGrid!, this.latinoDataSource as any)
        configureAlbumCustomDatasource(this.dataGrid!, this.supremeDataSource as any)
    }

    render() {
        return <div className="dashboard">
            <div className='charts'>
                <div className='bpm-container'>
                    <div className='row'>
                        <div className='col'>
                            <PlatformRenderer only={['supreme']}>
                                <DataGrid ref={(ref) => this.dataGrid = ref} dataSource={sp(this.context, { supreme: this.supremeDataSource, latino: this.latinoDataSource, default: undefined })}
                                    onSelectionChanged={e => {
                                        this.setState({ albumIds: e.selectedRowKeys || [] })
                                    }} selectedRowKeys={this.state.albumIds}
                                    allowColumnResizing allowColumnReordering columnResizingMode='widget' rowAlternationEnabled>
                                    <Column dataField={'id'} dataType={'number'} allowFiltering={true} allowSearch={true} filterOperations={['=']} />
                                    <Column dataField={'type'} dataType={'string'} filterValue={'audio'} visible={false}></Column>
                                    <Column dataField={'name'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
                                    <Column dataField={'artist'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
                                    <Column {...ActiveColumnOptions as any}></Column>
                                    <Column dataField={'is_remix'} caption={'Remix'} dataType={'string'} allowFiltering={true} allowSearch={false}></Column>
                                    <Column dataField={'major_label'} caption={'Major Label'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
                                    <Column dataField={'sub_label'} caption={'Sub Label'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
                                    <Column dataField={'bpm'} caption={'BPM'} dataType={'number'} allowFiltering={true}></Column>
                                    <Column dataField={'genre_name'} dataType={'string'} caption='Genre' allowFiltering={true} allowSearch={true} filterOperations={['=']} />
                                    <Column dataField={'category_name'} dataType={'string'} caption='Category' allowFiltering={true} allowSearch={true} />
                                    <Column dataField={'created_at'} allowSearch={false} allowHeaderFiltering={false} dataType={'datetime'} sortIndex={1} sortOrder={'desc'} visible={false} />
                                    <Column dataField={'created_by'} allowSearch={false} dataType={'string'} visible={false} />
                                    <Column dataField={'approved'} allowSearch={false} dataType={'boolean'} visible={false} />
                                    <Column dataField={'exclusive'} allowSearch={false} dataType={'boolean'} />
                                    <Column dataField={'remixer'} dataType={'string'} />
                                    <Column dataField={'intro_editor'} dataType={'string'} />
                                    <RemoteOperations
                                        sorting
                                        paging
                                        filtering
                                        groupPaging
                                        summary
                                    />
                                    <SearchPanel visible />
                                    <FilterRow visible />
                                    <HeaderFilter visible />
                                    <ColumnChooser enabled allowSearch />
                                    <StateStoring enabled storageKey='analytics_v3' />
                                    <Paging defaultPageSize={10} />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 15, 20, 30, 50]}
                                    />
                                    <Selection mode={'multiple'} />
                                </DataGrid>
                            </PlatformRenderer>
                            <PlatformRenderer only={['create']}>
                                <DataGrid dataSource={this.createDataSource} allowColumnReordering
                                    allowColumnResizing columnResizingMode='widget' rowAlternationEnabled
                                    onSelectionChanged={e => {
                                        this.setState({ albumIds: e.selectedRowKeys || [] })
                                    }} selectedRowKeys={this.state.albumIds}>
                                    <Column dataField={'id'} dataType={'string'} allowFiltering={true} allowSearch={true} filterOperations={['=']} />
                                    <Column dataField={'name'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
                                    <Column dataField={'catalog_id'} dataType={'string'} allowFiltering={true} allowSearch={true}></Column>
                                    <Column dataField={'slug'} dataType={'string'} allowFiltering={true} defaultVisible={false}></Column>
                                    <Column dataField={'description'} dataType={'string'} allowFiltering={true} allowSearch={true} defaultVisible={false}></Column>
                                    <Column dataField={'label_id'} caption='Label' dataType={'string'} allowFiltering={true} lookup={{ dataSource: LabelDatasource, valueExpr: 'id', displayExpr: 'name' }}></Column>
                                    <Column dataField={'genre_id'} caption='Genre' dataType={'string'} allowFiltering={true} lookup={{ dataSource: GenreDatasource, valueExpr: 'id', displayExpr: 'name' }}></Column>
                                    <Column dataField={'approved'} dataType={'boolean'} allowFiltering={true} allowSearch={false}></Column>
                                    <Column dataField={'notes'} dataType={'string'}></Column>
                                    <Column dataField={'created_by'} dataType={'string'} formItem={{ visible: false }} />
                                    <Column dataField={'created_at'} allowHeaderFiltering={false} allowSearch={false} dataType={'datetime'}
                                        formItem={{ visible: false }} defaultSortIndex={1} defaultSortOrder={'desc'} />

                                    <RemoteOperations
                                        sorting
                                        filtering
                                        summary
                                        paging
                                    />
                                    <StateStoring enabled storageKey='analytics_create_v3' />
                                    <SearchPanel visible />
                                    <FilterRow visible />
                                    <HeaderFilter visible />
                                    <ColumnChooser enabled allowSearch />
                                    <Paging defaultPageSize={10} />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 15, 20, 30, 50]}
                                    />
                                    <Selection mode={'multiple'} />
                                </DataGrid>
                            </PlatformRenderer>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <DownloadChart albumIds={this.state.albumIds} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <StreamChart albumIds={this.state.albumIds} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

function configureAlbumCustomDatasource(dataGrid: DataGrid, dataSource: { store: DevExpress.data.CustomStore }) {
    const originalLoad = dataSource.store.load.bind(dataSource.store)
    dataSource.store.load = (options?: DevExpress.data.LoadOptions) => {
        const lastSearchText = dataGrid.instance.option('searchPanel.text') as string
        if (options && options.filter && lastSearchText) {
            const changeFilter = (filter: Array<any>) => {
                let rowMatch = filter.map(valOrOperator => {
                    if (Array.isArray(valOrOperator) && valOrOperator.length == 3) {
                        let currentOperator = valOrOperator[1]
                        let currentName = valOrOperator[0]
                        return [currentName, currentOperator, '%%TO_SEARCH%%']

                    } else {
                        return valOrOperator
                    }
                })
                filter = lastSearchText!.split(' ').map(t => t.trim()).filter(Boolean).reduce((previous, value, index, array) => {
                    previous.push(rowMatch.map(valOrOperator => {
                        if (Array.isArray(valOrOperator) && valOrOperator.length == 3) {
                            return [valOrOperator[0], valOrOperator[1], value];
                        } else {
                            return valOrOperator
                        }
                    }))
                    if (index < (array.length - 1))
                        previous.push('and')
                    return previous
                }, new Array<any>())
                return filter
            }

            const checkForSearchTextFilter = (filter: Array<any>) => {
                if (Array.isArray(filter) && Array.isArray(filter[0]) && (filter[0].slice(-1) as any) == lastSearchText) {
                    return true
                }
                return false;
            }

            if (checkForSearchTextFilter(options.filter)) {
                options.filter = changeFilter(options.filter)
            } else {
                options.filter = options.filter.map(filter => {
                    if (checkForSearchTextFilter(filter)) {
                        return changeFilter(filter)
                    }
                    return filter
                })
            }

        }
        return originalLoad(options);
    }
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Compare/Compare.tsx